import React, { useId } from 'react';

function MarketplaceHexIcon({ name, iconUrl }) {
  const gradientId = useId().replace(/:/g, '');
  const initials = (name || '?')
    .split(/\s+/)
    .map((w) => w[0])
    .join('')
    .slice(0, 2)
    .toUpperCase();

  return (
    <div className='marketplace-hex-icon' aria-hidden>
      <svg viewBox='0 0 56 64' className='marketplace-hex-icon__shape' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M28 2 L52 15 L52 49 L28 62 L4 49 L4 15 Z'
          fill={`url(#${gradientId})`}
          stroke='rgba(120, 190, 230, 0.5)'
          strokeWidth='1'
        />
        <defs>
          <linearGradient id={gradientId} x1='0%' y1='0%' x2='100%' y2='100%'>
            <stop offset='0%' stopColor='#3d8fc4' />
            <stop offset='100%' stopColor='#2a6a94' />
          </linearGradient>
        </defs>
      </svg>
      <div className='marketplace-hex-icon__content'>
        {iconUrl ? (
          <img src={iconUrl} alt='' className='marketplace-hex-icon__img' />
        ) : (
          <span className='marketplace-hex-icon__initials'>{initials}</span>
        )}
      </div>
    </div>
  );
}

export default MarketplaceHexIcon;
